<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1Speakers",
  data: () => ({
    openProfiles: {}
  }),
  computed: {
    ...mapGetters("bahn1", ["mitwirkende"]),
    profiles() {
      return this.mitwirkende ? this.mitwirkende.Profile : [];
    }
  },
  methods: {
    photoUrl(profile) {
      return this.$store.getters.getStrapiImageUrl(profile.Profilbild);
    },
    isOpen(id) {
      return !!this.openProfiles[id];
    },
    toggle(id) {
      this.$set(this.openProfiles, id, !this.openProfiles[id]);
    }
  }
};
</script>

<template>
  <div class="speakers" v-if="profiles.length">
    <div class="speaker" v-for="profile in profiles" :key="profile.id">
      <div class="speaker-photo">
        <img :src="photoUrl(profile)" :alt="profile.ProfilName" />
        <span v-if="profile.Keynote" class="keynote-label">Keynote</span>
      </div>

      <div
        class="speaker-card"
        :class="{ 'speaker-card--open': isOpen(profile.id) }"
      >
        <div class="speaker-body">
          <div class="speaker-name">{{ profile.ProfilName }}</div>
          <p
            class="speaker-text"
            :class="{ 'speaker-text--clamped': !isOpen(profile.id) }"
          >
            {{ profile.ProfilText }}
          </p>
        </div>

        <button class="speaker-toggle" @click="toggle(profile.id)">
          {{ isOpen(profile.id) ? "Weniger lesen" : "Mehr lesen" }}
          <v-icon small>{{
            isOpen(profile.id) ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.speakers {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(296px, 100%), 1fr));
  gap: 24px;
  margin-bottom: 56px;
}
.speaker-photo {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  height: auto;
}
.speaker-photo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.keynote-label {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 84px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #008cc8;
  color: #ffffff;
  font-family: "GeometriaMedium", sans-serif;
  font-size: 13px;
}
.speaker-card {
  box-sizing: border-box;
  width: 100%;
  height: 208px;
  padding: 12px 16px;
  background: #ffffff;
  color: #1f2b37;
  display: flex;
  flex-direction: column;
}
.speaker-card--open {
  height: auto;
}
.speaker-body {
  flex: 0 0 auto;
  overflow: hidden;
}
.speaker-name {
  font-family: "GeometriaMedium";
  letter-spacing: 0.16px;
}
.speaker-text {
  margin: 8px 0 0;
  font-family: "GeometriaLight";
  letter-spacing: 0.32px;
  font-size: 16px;
  line-height: 1.4;
}
.speaker-text--clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 5;
  line-clamp: 5;
}
.speaker-toggle {
  margin-top: 16px;
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: "GeometriaGeometria";
  font-weight: bold;
  color: #b40055;
}
</style>
